import React from "react";

import { Box, Grid, Typography, colors, makeStyles } from "@material-ui/core";
import { CheckRounded } from "@material-ui/icons";
import { get } from "lodash";
import clsx from "clsx";
import htmlParser from "html-react-parser";

import { VisualValidatorProps } from "./types";

const useStyles = makeStyles(theme => ({
  base: {
    width: "100%",
    background: "white",
    display: "flex",
    color: theme.palette.action.active,
    paddingBottom: theme.spacing(2),
    "& *": {
      transition: "opacity 0.5s ease-in-out",
    },
    "& h1": {
      fontSize: "36px",
      fontWeight: "normal",
    },
    "& p": {
      fontSize: "12px",
      fontWeight: "normal",
    },
    "& h1, p": {
      color: "#B0BEC5",
      opacity: "1",
    },
    "& svg": {
      fill: colors.green[600],
      opacity: "0",
    },
    "&.valid": {
      "& h1, p": {
        opacity: "0.5",
      },
      "& svg": {
        opacity: "1",
      },
    },
  },
}));

const VisualValidator: React.FC<VisualValidatorProps> = ({
  isValid,
  icon: Icon,
  mainText,
  description,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Grid
      item
      xs={3}
      className={clsx(get(classes, "base"), isValid ? "valid" : "invalid")}
      {...rest}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        {Icon && <Icon className={get(classes, "icon")} />}
        {!Icon && mainText && (
          <Typography variant="h1">{htmlParser(mainText || "")}</Typography>
        )}
        <Typography variant="body2">{description}</Typography>
        <CheckRounded data-test="visual-validator-check" color="inherit" />
      </Box>
    </Grid>
  );
};

export default VisualValidator;
